import axios from "axios"
import toastr from "toastr"
import Cookies from "js-cookie"
import { param } from 'jquery'

class Banner {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
    this.fetchBanner()
  }

  cacheDOM () {
    this.$bpa_notice = $( '.bpa-notice' )
  }

  bindEvents () {
  }

  async fetchBanner () {
    const _self = this
    let blocked = new Set()

    const current_cookie_val = JSON.parse( Cookies.get( 'closed_banner' ) ? Cookies.get( 'closed_banner' ) : '[]' )

    current_cookie_val.forEach( element => {
      blocked.add( element )
    } )

    const res = await axios.get( '/wp-json/bpa/v1/banner', {
      params: {
        exclude: current_cookie_val,
        page_id: window.page_id
      }
    } )

    const messages = res?.data

    if ( messages ) {
      toastr.options = {
        containerId: 'banner-container',
        target: '.banner-container',
        maxOpened: 1,
        tapToDismiss: false,
        hideDuration: 1,
        positionClass: "toast-top-full-width",
        timeOut: 0,
        extendedTimeOut: 0,
        closeButton: true,
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
        closeHtml: `<button><img src='${ window.bpa_baseurl }/resources/images/icons/close-light.svg' width="17" height="17"></button>`,
      }

      messages.map( message => {
        if ( [ ...blocked ].includes( message.id ) ) { return }

        toastr.info( message.message, '', {
          onCloseClick: function ( e ) {
            blocked.add( message.id )
            Cookies.set( 'closed_banner', JSON.stringify( [ ...blocked ] ), { expires: 1 } )

            setTimeout( () => {
              _self.fetchBanner()
            }, 2000 )
          }
        } )
      } )

    }
  }
}

new Banner()
